import { useEffect, useMemo, useRef, useState } from 'react';
import { formatTime } from '../utils/formatTime';

export const useCountdown = <T>(timeLeft: number, onCountdownEnd?: () => T) => {
    const [countdown, setCountdown] = useState(timeLeft);

    const { hours, minutes, seconds } = useMemo(() => formatTime(countdown), [countdown]);

    const timerIdRef = useRef<NodeJS.Timeout>();

    useEffect(() => {
        if (timeLeft) setCountdown(timeLeft);
        else setCountdown(0);
    }, [timeLeft]);

    useEffect(() => {
        if (countdown <= 0) {
            clearInterval(timerIdRef.current);
            if (onCountdownEnd) onCountdownEnd();
        } else {
            timerIdRef.current = setInterval(() => setCountdown((pS) => pS - 1), 1000);
        }
        return () => clearInterval(timerIdRef.current);
    }, [countdown, onCountdownEnd]);

    return { countdown, hours, minutes, seconds };
};
